/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SurveysScopeFilter } from './surveysScopeFilter';
import { SurveysIncludeFilterItems } from './surveysIncludeFilterItems';


export interface SurveysIncludeFilterInner { 
    relation?: SurveysIncludeFilterInner.RelationEnum;
    scope?: SurveysScopeFilter;
}
export namespace SurveysIncludeFilterInner {
    export type RelationEnum = 'relations' | 'relationTypes' | 'status' | 'surveyResponses';
    export const RelationEnum = {
        Relations: 'relations' as RelationEnum,
        RelationTypes: 'relationTypes' as RelationEnum,
        Status: 'status' as RelationEnum,
        SurveyResponses: 'surveyResponses' as RelationEnum
    };
}


